export default {"src":"/_next/static/media/how-we-protect-you.7f18f368.svg","height":240,"width":220,"blurWidth":0,"blurHeight":0};